/* eslint-disable import/no-anonymous-default-export */
import { ProjectFileConfigShow } from './ProjectFileConfigShow';
import { ProjectFileConfigList } from './ProjectFileConfigList';
import { ProjectFileConfigEdit } from './ProjectFileConfigEdit';
import { ProjectFileConfigCreate } from './ProjectFileConfigCreate';
import { ProjectFileConfig } from '@/types';

export default {
    list: ProjectFileConfigList,
    show: ProjectFileConfigShow,
    edit: ProjectFileConfigEdit,
    create: ProjectFileConfigCreate,
    recordRepresentation: (record: ProjectFileConfig) =>
        record?.title,
};
